document.querySelectorAll('form.cart').forEach(function(productForm) {
    class ProductVariationsSidebar {
        constructor(productForm) {
            //Переменные
            this.sidebar = productForm.querySelector('.product-variations-sidebar');
            this.isNeedUpdateFilters = true;
            this.isNeedUpdateContent = true;
            this.availableVariations = JSON.parse(productForm.dataset.product_variations);
            this.filters = {};
            this.isHideCustomSizeLink = !!productForm.dataset.hideCustomSizeLink;

            //События
            //Установить статус обновления контента сайдбара
            jQuery(productForm).on('show_variation', () => this.isNeedUpdateContent = true);
            //Открыть сайдбар
            jQuery(productForm).on('click', '.variations-sidebar-trigger', () => {
                //Открыть оверлей
                jQuery(document.body).trigger('overlay_open');

                this.openSidebar();
            });
            //Закрыть сайдбар при закрытии оверлея
            jQuery(document.body).on('overlay_close', () => this.closeSidebar());
            //Открыть/закрыть фильтры
            jQuery(this.sidebar).on('click', '.filter-trigger', () => this.toggleFilters());
            //Применить фильтр
            jQuery(this.sidebar).on('keydown', 'input.filter', (event) => {
                //Запретить ввод букв в поле с типом число
                if ((event.currentTarget.type === 'number' || event.currentTarget.inputmode === 'numeric') && isLetterEntered(event)) {
                    event.preventDefault();
                }
                //Запретить отправку формы и вызвать событие изменение
                if (event.key === 'Enter') {
                    event.preventDefault();
                    event.currentTarget.dispatchEvent(new CustomEvent('change', {'bubbles': true}));
                }
            });
            jQuery(this.sidebar).on('change', 'input.filter', (event) => {
                this.validateFilter(event.currentTarget);
                this.updateContent();
            });
            //Выбрать вариацию
            jQuery(this.sidebar).on('click', '.item', (event) => {
                //Ничего не делаем, если клик по уже выбранной вариации
                if (event.currentTarget.classList.contains('active')) return;
                //Установить новую вариацию
                this.setVariation(event.currentTarget.dataset.id);
            });
            //Сменить угол вариации
            jQuery(this.sidebar).on('click', '.corner', () => {
                if (current_variation_corner === 'left') {
                    jQuery(productForm).trigger('variation_corner_change', 'right');
                } else if (current_variation_corner === 'right') {
                    jQuery(productForm).trigger('variation_corner_change', 'left');
                } else {
                    jQuery(productForm).trigger('variation_corner_change', '');
                }
            });
            jQuery(document.body).on('variation_corner_change', (event, corner) => this.setVariationCorner(corner));
        }

        openSidebar() {
            this.sidebar.classList.add('open');

            //Обновить содержимое сайдбара при открытии
            if (this.isNeedUpdateFilters) this.updateFilters();
            if (this.isNeedUpdateContent) this.updateContent();
        }

        closeSidebar() {
            this.sidebar.classList.remove('open');
        }

        toggleFilters() {
            this.sidebar.querySelector('.filter-button').classList.toggle('active');
            this.sidebar.querySelector('.filters').classList.toggle('open');
        }

        updateFilters() {
            //Меняем статус обновления фильтров
            this.isNeedUpdateFilters = false;

            //Подготавливаем данные для фильтров
            const lengths = this.availableVariations.map(variation => Number(variation['dimensions']['length']));
            this.filters['dimensions-length'] = {};
            this.filters['dimensions-length']['min'] = Math.min(...lengths);
            this.filters['dimensions-length']['max'] = Math.max(...lengths);

            //Формируем вёрстку фильтров
            const filters = this.sidebar.querySelector('.filters');
            filters.innerHTML = '';

            const wrapper = document.createElement('div');
            wrapper.classList.add('product-variations-sidebar-filters__wrapper');
            filters.appendChild(wrapper);

            //Первая строка фильтров
            const firstRow = document.createElement('div');
            firstRow.classList.add('product-variations-sidebar-filters__row');
            wrapper.appendChild(firstRow);

            const firstLabel = document.createElement('span');
            firstLabel.classList.add('product-variations-sidebar-filters__label');
            firstLabel.innerHTML = 'Длина';
            firstRow.appendChild(firstLabel);

            const firstFieldWrapper = document.createElement('div');
            firstFieldWrapper.classList.add('product-variations-sidebar-filters__field-wrapper');
            firstFieldWrapper.innerHTML = 'от';
            firstRow.appendChild(firstFieldWrapper);

            const firstLengthInput = document.createElement('input');
            firstLengthInput.classList.add('product-variations-sidebar-filters__field');
            firstLengthInput.classList.add('filter');
            firstLengthInput.dataset.name = 'minLength';
            firstLengthInput.dataset.default = this.filters['dimensions-length']['min'];
            firstLengthInput.inputmode = 'numeric';
            firstLengthInput.type = 'number';
            firstLengthInput.value = this.filters['dimensions-length']['min'];
            firstFieldWrapper.appendChild(firstLengthInput);

            const firstMeasureUnit = document.createElement('span');
            firstMeasureUnit.classList.add('product-variations-sidebar-filters__measure');
            firstMeasureUnit.innerHTML = 'см';
            firstFieldWrapper.appendChild(firstMeasureUnit);

            const secondFieldWrapper = document.createElement('div');
            secondFieldWrapper.classList.add('product-variations-sidebar-filters__field-wrapper');
            secondFieldWrapper.innerHTML = 'до';
            firstRow.appendChild(secondFieldWrapper);

            const secondLengthInput = document.createElement('input');
            secondLengthInput.classList.add('product-variations-sidebar-filters__field');
            secondLengthInput.classList.add('filter');
            secondLengthInput.dataset.name = 'maxLength';
            secondLengthInput.dataset.default = this.filters['dimensions-length']['max'];
            secondLengthInput.inputmode = 'numeric';
            secondLengthInput.type = 'number';
            secondLengthInput.value = this.filters['dimensions-length']['max'];
            secondFieldWrapper.appendChild(secondLengthInput);

            const secondMeasureUnit = document.createElement('span');
            secondMeasureUnit.classList.add('product-variations-sidebar-filters__measure');
            secondMeasureUnit.innerHTML = 'см';
            secondFieldWrapper.appendChild(secondMeasureUnit);

            //Вторая строка фильтров
            const secondRow = document.createElement('div');
            secondRow.classList.add('product-variations-sidebar-filters__row');
            wrapper.appendChild(secondRow);

            const slider = document.createElement('div');
            slider.classList.add('product-variations-sidebar-filters__slider');
            secondRow.appendChild(slider);
            jQuery(slider).slider({
                'range': true,
                'min': this.filters['dimensions-length']['min'],
                'max': this.filters['dimensions-length']['max'],
                'values': [this.filters['dimensions-length']['min'], this.filters['dimensions-length']['max']],
                'create': () => {
                    //Устанавливаем позицию в слайдере при ручном вводе значений в поля
                    firstLengthInput.addEventListener('change', () => {
                        //Задержка нужна, чтобы успела отработать валидация
                        setTimeout(() => {
                            jQuery(slider).slider('values', 0, firstLengthInput.value);
                            slider.classList.add('ui-state-focus');
                        }, 100);
                    });
                    secondLengthInput.addEventListener('change', () => {
                        //Задержка нужна, чтобы успела отработать валидация
                        setTimeout(() => {
                            jQuery(slider).slider('values', 1, secondLengthInput.value);
                        }, 100);
                    });

                },
                'slide': (event, ui) => {
                    if (ui['value'] === ui['values'][0]) firstLengthInput.value = ui['value'];
                    else if (ui['value'] === ui['values'][1]) secondLengthInput.value = ui['value'];
                },
                'stop': () => {
                    this.updateContent();
                }
            });
        }

        validateFilter(filterInput) {
            if (filterInput.dataset.name === 'minLength') {
                const maxLengthFilter = this.sidebar.querySelector('input.filter[data-name="maxLength"]');

                if (this.filters['dimensions-length']['min'] > Number(filterInput.value)) filterInput.value = this.filters['dimensions-length']['min'];
                if (Number(filterInput.value) > Number(maxLengthFilter.value)) filterInput.value = maxLengthFilter.value;
            } else if (filterInput.dataset.name === 'maxLength') {
                const minLengthFilter = this.sidebar.querySelector('input.filter[data-name="minLength"]');

                if (Number(minLengthFilter.value) > Number(filterInput.value)) filterInput.value = minLengthFilter.value;
                if (Number(filterInput.value) > this.filters['dimensions-length']['max']) filterInput.value = this.filters['dimensions-length']['max'];
            }
        }

        updateContent() {
            //Меняем статус обновления контента
            this.isNeedUpdateContent = false;

            //Если нет доступных вариаций, то прерываем процесс
            if (!Array.isArray(this.availableVariations) || this.availableVariations.length === 0) return;

            //Отфильтровать вариации
            let variations = this.filterItems(this.availableVariations);

            //Формируем контентную область
            const content = this.sidebar.querySelector('.content');
            content.innerHTML = '';

            if (variations.length) {
                //Сортировать вариации
                variations = this.sortItems(variations);

                //Если вариации подходящие под фильтры найдены
                variations.forEach((variation, index) => {
                    const url = new URL(window.location.href);
                    Object.keys(variation['attributes']).forEach(attributeName => {
                        url.searchParams.set(attributeName, variation['attributes'][attributeName]);
                    });

                    const item = document.createElement('a');
                    item.classList.add('product-variations-sidebar__item');
                    item.classList.add('item');
                    item.href = url.href;
                    if (current_variation['variation_id'] === variation['variation_id']) item.classList.add('active');
                    item.dataset.id = variation['variation_id'];
                    content.appendChild(item);
                    item.addEventListener('click', event => event.preventDefault());

                    const checked = document.createElement('div');
                    checked.classList.add('product-variations-sidebar__checked');
                    item.appendChild(checked);

                    if (variation['image']['secondPreview']) {
                        const secondPreview = document.createElement('img');
                        secondPreview.classList.add('product-variations-sidebar__second-preview');
                        secondPreview.src = variation['image']['secondPreview'];
                        item.appendChild(secondPreview);
                    }

                    const firstPreview = document.createElement('img');
                    firstPreview.classList.add('product-variations-sidebar__first-preview');
                    firstPreview.src = variation['image']['thumb_src'];
                    item.appendChild(firstPreview);

                    if (item.classList.contains('active') && current_variation_corner) {
                        const corner = document.createElement('div');
                        corner.classList.add('product-variations-sidebar__corner');
                        corner.classList.add('corner');
                        if (current_variation_corner === 'right') corner.classList.add('flip');
                        item.appendChild(corner);
                    }

                    if (Object.keys(variation['zarbo']).length) {
                        const AR = document.createElement('div');
                        AR.classList.add('product-variations-sidebar__ar');
                        AR.innerHTML = 'AR';
                        item.appendChild(AR);
                    }

                    const title = document.createElement('span');
                    title.classList.add('product-variations-sidebar__title');
                    title.innerHTML = variation['attribute_labels'][Object.values(variation['attributes'])[0]];
                    item.appendChild(title);

                    const regularPrice = document.createElement('span');
                    regularPrice.classList.add('product-variations-sidebar__price');
                    if (variation['display_regular_price'] !== variation['display_price']) regularPrice.classList.add('del');
                    regularPrice.innerHTML = 'от <b>'
                        + new Intl.NumberFormat("ru-RU").format(variation['display_regular_price']) + '</b> ₽';
                    item.appendChild(regularPrice);

                    if (variation['display_regular_price'] !== variation['display_price']) {
                        const salePrice = document.createElement('span');
                        salePrice.classList.add('product-variations-sidebar__price');
                        salePrice.innerHTML = 'от <b>'
                            + new Intl.NumberFormat("ru-RU").format(variation['display_price']) + '</b> ₽';
                        item.appendChild(salePrice);
                    }

                    if (!this.isHideCustomSizeLink && (index === 6 || (variations.length < 7 && index === variations.length - 1))) {
                        const additionalItem = document.createElement('div');
                        additionalItem.classList.add('product-variations-sidebar__item');
                        additionalItem.classList.add('pum-trigger');
                        additionalItem.classList.add('popmake-56289');
                        content.appendChild(additionalItem);

                        const additionalPreview = document.createElement('img');
                        additionalPreview.classList.add('product-variations-sidebar__first-preview');
                        additionalPreview.src = variation['image']['full_src'];
                        additionalItem.appendChild(additionalPreview);

                        const overlay = document.createElement('div');
                        overlay.classList.add('product-variations-sidebar__overlay');
                        additionalItem.appendChild(overlay);

                        const overlayText = document.createElement('span');
                        overlayText.classList.add('product-variations-sidebar__overlay-text');
                        overlayText.innerHTML = '<b>Не нашли размер?</b><br><br>Рассчитаем изготовление под ваши габариты';
                        overlay.appendChild(overlayText);

                        const overlayButton = document.createElement('div');
                        overlayButton.classList.add('product-variations-sidebar__overlay-button');
                        overlayButton.innerHTML = 'Оставить заявку';
                        overlay.appendChild(overlayButton);
                    }
                });
            }

            //Формируем футер сайдбара
            const footer = this.sidebar.querySelector('.product-variations-sidebar-footer');
            footer.innerHTML = '';

            const minLengthInput = this.sidebar.querySelector('input.filter[data-name="minLength"]');
            const maxLengthInput = this.sidebar.querySelector('input.filter[data-name="maxLength"]');
            if (
                minLengthInput && maxLengthInput
                && (minLengthInput.value !== minLengthInput.dataset.default || maxLengthInput.value !== maxLengthInput.dataset.default)
            ) {
                const firstRow = document.createElement('div');
                firstRow.classList.add('product-variations-sidebar-footer__row');
                footer.appendChild(firstRow);

                const resetLength = document.createElement('span');
                resetLength.classList.add('product-variations-sidebar-footer__reset');
                resetLength.classList.add('reset');
                resetLength.innerHTML = 'Длина: от ' + minLengthInput.value + ' см до ' + maxLengthInput.value + ' см';
                firstRow.appendChild(resetLength);

                const resetLengthClose = document.createElement('span');
                resetLengthClose.classList.add('product-variations-sidebar-footer__close');
                resetLength.appendChild(resetLengthClose);
                resetLengthClose.addEventListener('click', () => {
                    minLengthInput.value = minLengthInput.dataset.default;
                    minLengthInput.dispatchEvent(new CustomEvent('change', {'bubbles': true}));

                    maxLengthInput.value = maxLengthInput.dataset.default;
                    maxLengthInput.dispatchEvent(new CustomEvent('change', {'bubbles': true}));
                });
            }
        }

        filterItems(items) {
            const filters = this.sidebar.querySelectorAll('input.filter');

            items = items.filter(item => {
                //Если это текущая вариация, то не отфильтровываем
                if (current_variation['variation_id'] === item['variation_id']) return true;

                //Проверяем на то, подходит ли вариация под фильтры
                var isRightItem = true;
                filters.forEach(filter => {
                    //Минимальная длинна вариации
                    if (
                        filter.dataset.name === 'minLength'
                        && Number(item['dimensions']['length']) < Number(filter.value || filter.dataset.default)
                    ) {
                        isRightItem = false;
                    }
                    //Максимальная длинна вариации
                    else if (
                        filter.dataset.name === 'maxLength'
                        && Number(item['dimensions']['length']) > Number(filter.value || filter.dataset.default)
                    ) {
                        isRightItem = false;
                    }
                });
                return isRightItem;
            });

            return items;
        }

        sortItems(items) {
            const {compare} = new Intl.Collator(undefined, {numeric: true});

            return items.sort((a, b) => compare(Object.values(a['attributes'])[0], Object.values(b['attributes'])[0]));
        }

        setVariation(id) {
            //Получаем объект вариации, что хотим применить
            const variation = this.availableVariations.find(variation => variation['variation_id'] === Number(id));

            //Устанавливаем значения атрибутов у селекторов
            Object.keys(variation['attributes']).forEach(attribute => {
                document.querySelector('.variations select.variations-selector[data-attribute_name="' + attribute + '"]')
                    .value = variation['attributes'][attribute];
            });

            //Закрываем сайдбар
            jQuery(document.body).trigger('overlay_close');
            this.closeSidebar();

            //Тригерим проверку атрибутов и установку новой вариации
            jQuery(productForm).trigger('woocommerce_variation_select_change');
            jQuery(productForm).trigger('check_variations');
        }

        setVariationCorner(corner) {
            const cornerItem = this.sidebar.querySelector('.item.active .corner');

            if (cornerItem && corner === 'right') {
                cornerItem.classList.add('flip');
            } else if (cornerItem && corner === 'left') {
                cornerItem.classList.remove('flip');
            }
        }
    }

    //Инициализировать сайдбар при первой установке вариации
    jQuery(productForm).one('show_variation', () => {
        new ProductVariationsSidebar(productForm);
    });
});